<modal
  [title]="title"
  (close)="close.emit()"
  [width]="'850px'"
  (closeMethodRef)="closeMethodRef = $event"
>
  <div class="rv-rows large outer">
    <div>
      <ng-content></ng-content>
    </div>
  </div>
  <footer class="rv-flex">
    <div class="rv-link rv-left mr-auto" *ngIf="leftLink">
      <button
        rivButton
        [variant]="'ghost'"
        class="rv-left"
        (click)="innerModalAction.emit()"
        [icon]="iconName"
      >
        {{ leftLinkText }}
      </button>
    </div>
    <div class="rv-button-set rv-right">
      <button rivButton (click)="setCloseMethod('Click close'); close.emit()">
        Close
      </button>
    </div>
  </footer>
</modal>
